export default "__VITE_ASSET__DwAIY1kX__"